import React, { memo, useMemo } from 'react';
import useCountDown from '../../hooks/useCountDown';
import { addJpDate, formatJpDate } from '../../utils';
import { USING_PERIOD_UNIT } from '../../utils/Constants';
import styles from './styles.module.css';
import { OrderTicket } from 'types';

/**
 * 残り時間の表示
 */
type DisplayPeriodTimeProps = {
    textColor?: string;
    orderTicket: OrderTicket;
    circleSize?: number;
};

const DisplayPeriodTime = memo(({ textColor = '#000000', orderTicket, circleSize }: DisplayPeriodTimeProps) => {
    const { usingPeriod, usingPeriodUnit, orderUsageTickets } = orderTicket ?? {};
    const { expiredAt, activatedAt } = orderUsageTickets?.[0] ?? {};

    const size = 200;
    const y = 93; // 高さ基準

    const countDownText = useCountDown({
        limit: expiredAt,
    });

    // 日券の表示上の有効期限
    const displayExpiredAt = useMemo(() => {
        if (usingPeriodUnit === USING_PERIOD_UNIT.DAY) {
            return addJpDate(activatedAt, (usingPeriod ?? 1) - 1, 'day');
        }
    }, [activatedAt, usingPeriodUnit, usingPeriod]);

    return (
        <div className={styles.container}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 ${size} ${size}`}
                width={`${circleSize ?? 300}px`}
                height={`${circleSize ?? 300}px`}
                fill={textColor}
            >
                {usingPeriodUnit === USING_PERIOD_UNIT.MINUTE ? (
                    <>
                        <rect
                            x={55}
                            y={49}
                            width="90"
                            height="20"
                            rx="10"
                            ry="10"
                            style={{ fill: 'none', stroke: textColor, strokeWidth: 0.8 }}
                        ></rect>
                        <text
                            fontSize={11}
                            x={size / 2}
                            y={y - 30}
                            textAnchor="middle"
                            fontFamily="NotoSansJP"
                            fontWeight="bold"
                        >
                            {'残り使用時間'}
                        </text>
                        <text
                            fontSize={35}
                            x={size / 2}
                            y={y + 15}
                            textAnchor="middle"
                            fontFamily="NotoSans"
                            fontWeight="bold"
                        >
                            {countDownText}
                        </text>
                    </>
                ) : (
                    <>
                        {usingPeriod !== 1 && (
                            <>
                                <rect
                                    x={55}
                                    y={51}
                                    width="90"
                                    height="20"
                                    rx="10"
                                    ry="10"
                                    style={{ fill: 'none', stroke: textColor, strokeWidth: 0.8 }}
                                ></rect>
                                <text
                                    fontSize={12}
                                    x={100}
                                    y={63}
                                    dominantBaseline="middle"
                                    textAnchor="middle"
                                    fontFamily="NotoSans"
                                    fontWeight="bold"
                                >
                                    {activatedAt && formatJpDate(activatedAt, 'MM月DD日から')}
                                </text>
                            </>
                        )}
                        <text
                            fontSize={46}
                            x={size / 2 - 40}
                            y={y + 19}
                            textAnchor="middle"
                            fontFamily="NotoSans"
                            fontWeight="bold"
                        >
                            {displayExpiredAt ? formatJpDate(displayExpiredAt, 'MM') : '--'}
                        </text>
                        <text fontSize={15} x={size / 2 - 7} y={y + 19} textAnchor="middle" fontFamily="NotoSans">
                            {'月'}
                        </text>
                        <text
                            fontSize={46}
                            x={size / 2 + 28}
                            y={y + 19}
                            textAnchor="middle"
                            fontFamily="NotoSans"
                            fontWeight="bold"
                        >
                            {displayExpiredAt ? formatJpDate(displayExpiredAt, 'DD') : '--'}
                        </text>
                        <text fontSize={15} x={size / 2 + 62} y={y + 19} textAnchor="middle" fontFamily="NotoSans">
                            {'日'}
                        </text>
                    </>
                )}
            </svg>
        </div>
    );
});

export default DisplayPeriodTime;
